<!-- Material DATEPICKER -->
<mat-form-field>
  <mat-label>{{ translatedLabel() ?? (label() | translate) }}</mat-label>
  <input
    matInput
    autocomplete="off"
    [placeholder]="placeholder()"
    [value]=" (date !== null) ? (date | date: _dateFormat) : ''"
    (change)="dateInputChangeHandler($event)"
    [formControl]="control"
    #input
    />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker
    #picker="matDatepicker"
    [startView]="view()"
    (yearSelected)="chosenYearHandler($event, picker)"
    (monthSelected)="chosenMonthHandler($event)"
    >
    <input
      matInput
      [min]="minDate"
      [max]="maxDate"
      [matDatepicker]="picker"
      [formControl]="dateCtlPicker"
      (dateChange)="dateChanged($event)"
      />
  </mat-datepicker>
  @if (control?.invalid) {
    <mat-error [innerHTML]="control.errors | errorTranslate"></mat-error>
  }
</mat-form-field>
